const inputNormalizer = (value, name, callback) => {
  const e = {
    target: {
      name: name,
      value: value
    }
  }

  if(typeof callback === 'function'){
    callback(e)
  }
}

export { inputNormalizer }
